import { render } from "./HeaderBG.vue?vue&type=template&id=481608a4"
const script = {}

import "./HeaderBG.vue?vue&type=style&index=0&id=481608a4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__